import { MonacoEditor } from './App';

export function MonacoEditorDefaultWrapper() {
	return (
		<MonacoEditor
			useLocalStorage={true}
			initialValue={undefined}
		/>
	);
}

export function MonacoEditorTutorialWrapper() {
	return (
		<MonacoEditor
			useLocalStorage={false}
			initialValue={`
~ Opozorilo: V tem vodiču se tvoja koda ne shranjuje!
PRINTLN_TEXT \`Hiter uvod v ELF script!\`


~ Za celo-vrstične komentarje uporabi znak "~" na začetku vrstice. Delujejo le, če je znak res na začetku.

    (Več-vrstični komentarji lahko postaviš kjerkoli v kodi.
    Če vsebujejo zaklepaj, ga je potrebno ubežati z "\\", npr.: (ne boš me zaključil\\) pa res!
Komentarji podpirajo tudi ne-ASCII znake, npr. 😎)


DEBUGPOINT (ta vrstica se zažene samo v debug načinu)
PRINT_TEXT \`Nastavi konstantno "moja_konstanta" na vrednost 1: \`
CONSTANT moja_konstanta 1 (ta vrstica ne obstaja ob izvajanju, saj se konstanta prevede v število)
PRINTLN moja_konstanta

PRINT_TEXT \`Ker se konstante prevedejo pred izvajanjem, jih lahko definiramo v kodi kasneje, kot pred uporabo: \`
PRINTLN moja_konstanta2
CONSTANT moja_konstanta2 2

PRINT_TEXT \`Pomnilnik na mestu 42 nastavi na vrednost 1: \`
SET [42] 1
PRINTLN [42]

PRINT_TEXT \`Register 4 nastavi na vrednost 1: \`
SET @4 1
PRINTLN @4

PRINT_TEXT \`Akumulatorski register nastavi na vrednost 1: \`
SET @ 1
PRINTLN @

PRINT_TEXT \`Ce zelimo ascii vrednost (npr. A) zapisati kot stevilo: \`
SET @1 #\`A\`
PRINTLN @1

PRINT_TEXT \`Seveda lahko stevila zamenjajo izrazi, ki se lahko gnezdijo: \`
SET [1] 42
SET @1 [[[[[ADD 40 ADD 1 1]]]]] (kazalec na kazalec na kazalec...)
PRINTLN @1

PRINT_TEXT \`Kontrolna stavka IF in WHILE: \`
WHILE GT @1 0 {
    PRINT @1
    SET @1 ADD @1 1
    IF EQ @1 5 {
        PRINTLN_TEXT \`!\`
        BREAK
    } ELSE {
        PRINT_TEXT \`... \`
        CONTINUE
    }
    PRINT_TEXT \`?\`
}

FUNCTION moja_funkcija {
    EXIT 42
}

FUNCTION moja_funkcija_args {
    POP { @1 @2 }
    EXIT ADD @1 @2
}

PRINT_TEXT \`Klic funkcije: \`
PRINTLN CALL moja_funkcija

PRINT_TEXT \`Klic funkcije in prenos argumentov preko sklada: \`
PUSH { 1 2 }
PRINTLN CALL moja_funkcija_args

PRINT_TEXT \`Tako kot konstante, lahko funkcije klicemo pred njihovo definicijo: \`
PRINTLN CALL moja_funkcija2

FUNCTION moja_funkcija2 {
    EXIT 43
}

PRINT_TEXT \`Pri zapisu tega jezika si lahko kreativen: \`
SET [moja_konstanta] 
    ADD 
        3
        SUB 
            ADD 
                5
                5
            5
PRINTLN [moja_konstanta]

PRINT_TEXT \`lahko uporabis tudi posebne znake kot so \\t<-tab \\\\<-slash \\n<-newline...\\n\`
PRINT_TEXT \`ali pa spremenis barvo konzole...\`
PRINT_TEXT { 27 91 51 49 109 }
PRINT_TEXT \` cool :)!\`
PRINT_TEXT { 27 91 48 109 }
PRINT_TEXT \`\\n\`
PRINT_TEXT \`mogoce je celo izpisati \` PRINT_TEXT 353 PRINTLN_TEXT \`umnik!\`
PRINTLN_TEXT \`Tukaj se bo pa program predcasno zakljucil...\`
TERMINATE 0
PRINT_TEXT \`To se ne bo izvedlo.\`
`} />
	);
}
